import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { FazerPedidoService } from 'src/app/services/fazer-pedido.service';
import { AlertSucessoComponent } from '../alert-sucesso/alert-sucesso.component';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FieldErrorComponent } from '../field-error/field-error.component';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-alert-alterar-endereco',
    templateUrl: './alert-alterar-endereco.component.html',
    styleUrls: ['./alert-alterar-endereco.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertSucessoComponent, NgClass, FormsModule, FieldErrorComponent, CamelCasePipe, CnpjPipe]
})
export class AlertAlterarEnderecoComponent implements OnInit {

  @Input() alertAlterarEndereco: boolean = false;
  @Input() enderecoSelecionado: any;
  @Input() idEmpresa: number;
  @Input() idImportacao: any;
  @Input() idPedidoAtivo: any;
  @Output() alertAlterarEnderecoFechou = new EventEmitter( );

  // public formData = new FormData();
  public newEnderecoSelecionado: any = '';

  public enderecosFaturamento: any;
  public showAlertSucesso: boolean = false;
  public enderecoSelecionadoError: boolean = false;
  public endereco: any;
  public contatoSelecionadoError: boolean;
  public contatoSelecionado: any;
  public isErrorFields = false;

  constructor(private readonly fazerPedidoService: FazerPedidoService) { }

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.fazerPedidoService.getAllEnderecosFaturamento(this.idEmpresa)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.enderecosFaturamento = response.response;
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  fecharAlertAlterarEndereco() {
    if (this.newEnderecoSelecionado.length > 0 ) {
      const endereco = this.enderecosFaturamento.find( (x) => { return x.idEndereco == this.newEnderecoSelecionado } );
      this.alertAlterarEnderecoFechou.emit( endereco );
    }
  }

  eventoAlertSucesso(evento: any) {
    this.showAlertSucesso = false;
  }

  abrirAlertSucesso() {
    this.showAlertSucesso = true;
    this.fecharAlertAlterarEndereco();
  }

  onEnderecoSelecionado(){
    this.enderecoSelecionadoError = this.newEnderecoSelecionado.length === 0;
  }

  cancelarAlterarEndereco(){
    this.alertAlterarEnderecoFechou.emit(false);
    this.alertAlterarEndereco = false;
  }

  onSubmit() {
    if (this.newEnderecoSelecionado.length === 0 ){
      this.enderecoSelecionadoError = true;
    }
    else {
      this.fazerPedidoService.newEnderecoFaturamento(this.idEmpresa, this.idPedidoAtivo, this.newEnderecoSelecionado)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.abrirAlertSucesso();
        },
        error: (error) => {
          console.log(error)
        }
      })
    }
  }
}
